<template>
    <section>
        <div v-if="loading">
            <Loading />
        </div>
        <div v-else>
            <Nav />
            <section class="card-container">
                <h1>{{ $t('themes_page.title') }}</h1>
                <p>{{ $t('themes_page.intro') }}</p>
                <p>{{ $t('themes_page.intro_prompt') }}</p>
                <ul id="themes"
                    v-if="list.length > 0"
                    class="cards" :class="{'grid': list.length > 1, 'small-grid': list.length < 4}">
                    <ThemeCard v-for="item in list" v-bind:key="item.id" :model="item" />
                </ul>
                <p v-else class="no-results">{{ $t('labels.no_results') }}</p>
            </section>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

import Loading from '@/components/Loading'
import Nav from '@/components/Nav'
import ThemeCard from '@/components/ThemeCard'

export default {
    components: {
        Loading,
        Nav,
        ThemeCard
    },
    data(){
        return {
            images: {}
        }
    },
    computed: {
        ...mapGetters({
            'list': 'themes/list',
            'loading': 'themes/list_loading',
            'theme': 'themes/theme',
        })
    },
    head: {
        title: function() {
            return {
                inner: this.$i18n.t('themes_page.title'),
                separator: '|',
                complement: this.$i18n.t('main.museum_name')
            }
        },
        meta: function() {
            return [
                {rel: 'canonical', href: this.$i18n.t('main.cannonical'), id: 'rel-con'},
                {rel: 'alternate', href: this.$i18n.t('main.alternate'), hreflang: this.$i18n.t('main.alternate_locale'), id: 'rel-alt'},

                {name: 'description', content: this.$i18n.t('themes_page.intro'), id: 'desc'},

                {property: 'og:title', content: `${this.$i18n.t('themes_page.title')} | ${this.$i18n.t('main.museum_name')}`, id: 'og-title'},
                {property: 'og:description', content: this.$i18n.t('themes_page.intro'), id: 'og-desc'},
                {property: 'og:type', content: 'website', id: 'og-type'},
                {property: 'og:locale', content: this.$i18n.locale, id: 'og-locale'},
                {property: 'og:image', content: `${window.location.host}${this.$i18n.t('themes_page.preview_image')}`, id: 'og-image'}
            ]
        }
    },
    watch: {
        '$route': {
            handler: function(to, from) {
                let query = Object.assign({}, this.$route.query);
                this.$store.dispatch('themes/search', query.q)
            }
        }
    },
    async mounted() {
        await this.$store.dispatch("themes/clear_search")

        await this.$store.dispatch("themes/fetch_list", {
            locale: this.$i18n.locale
        })
    }
}
</script>